import React from 'react';
import { Tooltip } from 'react-tooltip';
import HelpCircle from 'src/app/icons/Monospaced/HelpCircle/HelpCircle';
import { HelpCircleHintContainer } from './HelpCircleHint.styles';

interface HelpCircleHintProps {
  hint: string;
  id: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

const HelpCircleHint = ({ hint, id, placement = 'left' }: HelpCircleHintProps): JSX.Element => (
  <HelpCircleHintContainer
    justify='center'
    align='center'
  >
    <Tooltip
      id={id}
      className='label-tooltip'
    />
    <a
      data-tooltip-id={id}
      data-tooltip-html={`<p class="tooltip-text">${hint}</p>`}
      data-tooltip-place={placement}
      className='tooltip-anchor'
    >
      <HelpCircle />
    </a>
  </HelpCircleHintContainer>
);

export default HelpCircleHint;
